webpackJsonp([121364257223524],{

/***/ 391:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulProject":{"title":"Split Ball","createdAt":"August 17th, 2018","images":[{"file":{"url":"//images.ctfassets.net/td17hthlq11b/2B0PFHp8qEUOAIM8Iy662a/b53c0a10f30655cc3d9f767d114eb365/1.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/3TADxAajEIGC4qIeqsYagO/6ebdc5bc9218e9f473ca7c7a184fea43/2.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/BrpPvXgyTm8ic2gcY2wki/77aa41e3a9a8c2d72d189d217506834a/3.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/3fcLcXN6Jy8wqSqySiqak6/50ea7b8df6050729ac7366677035e94a/4.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/2FTQB2frVuY6KWciMiQwOG/6afa226c7fe038b54c87f74d2c88bc18/5.JPG"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/11QqFsdXsiW8OY6ICISuuO/3e6ce0390e746fa1399e8816436a595d/6.jpg"}}],"description":null}},"pathContext":{"slug":"split-ball"}}

/***/ })

});


// WEBPACK FOOTER //
// path---project-split-ball-320ad225d2a233a9bf23.js